function targetBoxes(target, resolution) {
  if (target?.resolution !== resolution) return []
  return Array.isArray(target?.span?.bbox) ? target.span.bbox : []
}

function legacyBoxes(citation, resolution) {
  const isExact = citation?.span_resolution === 'exact' || citation?.span_resolution === 'resolved'
  const matches = resolution === 'exact' ? isExact : citation?.span_resolution === 'coarse'
  return matches && Array.isArray(citation?.span?.bbox) ? citation.span.bbox : []
}

export function citationBoxes(citation, resolution) {
  if (!Array.isArray(citation?.targets)) return legacyBoxes(citation, resolution)
  return citation.targets.flatMap((target) => targetBoxes(target, resolution))
}

export function boxesByPage(citation, resolution) {
  const map = {}
  if (!Array.isArray(citation?.targets)) {
    const page = Number(citation?.page)
    const boxes = legacyBoxes(citation, resolution)
    if (Number.isFinite(page) && boxes.length) map[page] = boxes
    return map
  }
  for (const target of citation.targets) {
    const page = Number(target?.page ?? citation?.page)
    const boxes = targetBoxes(target, resolution)
    if (!Number.isFinite(page) || !boxes.length) continue
    ;(map[page] ||= []).push(...boxes)
  }
  return map
}

/** The target a specific marker occurrence refers to, when its quote bound one. */
export function focusedTarget(citation, targetIndex) {
  if (!Array.isArray(citation?.targets) || !(targetIndex >= 0)) return null
  return citation.targets[targetIndex] ?? null
}

export function focusedBoxes(citation, targetIndex) {
  const target = focusedTarget(citation, targetIndex)
  return target && target.resolution !== 'failed' ? targetBoxes(target, target.resolution) : []
}

export function primaryPage(citation, targetIndex = -1) {
  const focused = focusedTarget(citation, targetIndex)
  if (focused?.resolution !== 'failed' && Number.isFinite(focused?.page)) return focused.page
  const usable = citation?.targets?.find((target) => target.resolution !== 'failed')
  return usable?.page ?? citation?.page ?? 1
}
